import * as OrdersPayloadType   from 'shared/types/OrdersPayload';
import * as OrdersType          from 'Dispatcher/components/Orders';

interface Props extends OrdersType.Props {
    max_ms : number;
}

export default class LateOrders extends OrdersType.Orders<Props> {
    protected fetchRows( orderby:string, limit:number, skip:number ) {
        return this.getTablePromise<OrdersPayloadType.Dehydrated<number>>(
            '/api/dispatcher/orders/late',
            'GET',
            undefined,
            {orderby,limit,skip,max_ms:this.props.max_ms}
        ).then(OrdersPayloadType.hydrate);
    }
}

